/**
 * CondRow — a single filter condition row (field + operator + value).
 */
import React from 'react';
import { Button } from '../ui/button';
import { X } from 'lucide-react';
import { OPERATORS, NO_VALUE_OPS } from './filterConstants';
import ValueInput from './ValueInput';

export default function CondRow({ cond, fields, onChange, onRemove }) {
  const fd = fields.find(f => f.key === cond.field);
  const ft = fd?.type || 'string';
  const ops = OPERATORS[ft] || OPERATORS.string;

  const handleFieldChange = (key) => {
    const def = fields.find(f => f.key === key);
    const nt = def?.type || 'string';
    const nOps = OPERATORS[nt] || OPERATORS.string;
    const valid = nOps.some(o => o.value === cond.operator);
    onChange({ ...cond, field: key, operator: valid ? cond.operator : nOps[0].value, value: '' });
  };

  return (
    <div className="flex items-center gap-1.5 group" data-testid="filter-condition-row">
      <select value={cond.field} onChange={e => handleFieldChange(e.target.value)}
        className="h-7 text-xs border rounded px-1.5 w-[160px] bg-white truncate" data-testid="filter-field-select">
        <option value="">-- Field --</option>
        {fields.map(f => <option key={f.key} value={f.key}>{f.label}</option>)}
      </select>
      <select value={cond.operator} onChange={e => onChange({ ...cond, operator: e.target.value })}
        className="h-7 text-xs border rounded px-1.5 w-[110px] bg-white" data-testid="filter-operator-select">
        {ops.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {!NO_VALUE_OPS.has(cond.operator) && <ValueInput cond={cond} fieldDef={fd} fType={ft} onChange={onChange} />}
      <Button size="icon" variant="ghost" onClick={onRemove}
        className="h-6 w-6 opacity-0 group-hover:opacity-100 text-destructive" data-testid="filter-remove-condition">
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
